import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label", "LabelComponent"];
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getBrandKitId } from 'ContentData/selectors/branding';
import styled from 'foundations-theming/utils';
import SanitizedLabel from 'ContentComponents/components/cmv2/SanitizedLabel';
import FieldInheritanceIcon from 'ContentComponents/components/cmv2/FieldInheritanceIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RefreshIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Box } from 'foundations-components/transitional/components/Box';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.${key}`;
const InlineFlexSpan = styled.span.withConfig({
  displayName: "EditFormLabel__InlineFlexSpan",
  componentId: "xiojew-0"
})(["display:inline-flex;"]);
const mapStateToProps = state => {
  return {
    brandKitId: getBrandKitId(state)
  };
};
const connector = connect(mapStateToProps);
class EditFormLabel extends PureComponent {
  constructor(props) {
    super(props);
    this.handleResetClick = this.handleResetClick.bind(this);
    this.renderResetButton = this.renderResetButton.bind(this);
  }
  get isOccurrence() {
    const {
      fieldKey
    } = this.props;
    return fieldKey.some(val => typeof val === 'number');
  }
  handleResetClick(evt) {
    const {
      fieldKey,
      onFieldReset
    } = this.props;
    evt.stopPropagation();
    evt.preventDefault();
    onFieldReset(fieldKey);
  }
  renderInheritanceIcon() {
    const {
      inheritedValue,
      isDefaultValue,
      isOccurrencesLabel,
      scrollToField,
      label,
      LabelComponent,
      allowFieldReset,
      onFieldUnlink
    } = this.props;
    /*
      Repeated fields can only inherit their values via default_value_path
      If inheriting via property_value_paths or a child is configured to inherit,
      we cannot show the inheritance icon because repeated values can only be
      overriding values, so it won't actually be linked to the inheritance source
      if the source value changes
    */
    const {
      property_value_paths: isInheritingProperty
    } = inheritedValue || {};
    const isRepeatingAndInheritingProperty = isInheritingProperty && isOccurrencesLabel;
    if (!allowFieldReset || this.isOccurrence || isRepeatingAndInheritingProperty || !(LabelComponent || label)) return null;
    return /*#__PURE__*/_jsx(FieldInheritanceIcon, {
      inheritedValue: inheritedValue,
      isDefaultValue: isDefaultValue,
      onResetClick: this.handleResetClick,
      onUnlinkClick: onFieldUnlink,
      scrollToField: scrollToField
    });
  }
  renderResetButton() {
    const {
      isDefaultValue,
      allowFieldReset,
      LabelComponent,
      label
    } = this.props;
    if (isDefaultValue || this.isOccurrence || !allowFieldReset) return null;
    if (!(LabelComponent || label)) return null;
    return /*#__PURE__*/_jsx(IconButton, {
      marginInlineStart: "100",
      onClick: this.handleResetClick,
      size: "xs",
      tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('resetButton.resetFieldTooltip')
      }),
      block: false,
      use: "link",
      children: /*#__PURE__*/_jsx(RefreshIcon, {})
    });
  }
  renderLabel() {
    const _this$props = this.props,
      {
        label,
        LabelComponent
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    if (!label) return null;
    if (LabelComponent) {
      return /*#__PURE__*/_jsx(LabelComponent, Object.assign({}, rest, {
        label: label
      }));
    }
    return label && /*#__PURE__*/_jsx(SanitizedLabel, {
      label: label
    });
  }
  render() {
    const {
      inheritedValue,
      truncate
    } = this.props;
    const {
      inheritanceType
    } = inheritedValue || {};
    const inheritanceOrResetButton = inheritanceType ? this.renderInheritanceIcon() : this.renderResetButton();
    const label = this.renderLabel();
    return truncate ? /*#__PURE__*/_jsx(TruncateString, {
      alignItems: "center",
      maxInlineSize: "100%",
      matchContentWidth: true,
      fixedChildren: inheritanceOrResetButton,
      useFlex: true,
      children: label
    }) : /*#__PURE__*/_jsxs(InlineFlexSpan, {
      children: [/*#__PURE__*/_jsx(Box, {
        flexShrink: 1,
        maxInlineSize: "100%",
        children: label
      }), inheritanceOrResetButton]
    });
  }
}
EditFormLabel.defaultProps = {
  isDefaultValue: true
};
export default connector(EditFormLabel);